
export const API_CONFIG = {
  basePath: '/lmrc-rest'
};



// WEBPACK FOOTER //
// ./client/app/app.config/api-config.constants.js